import { render, staticRenderFns } from "./frontBackaAppraisal_tea.vue?vue&type=template&id=675d64aa&scoped=true&"
import script from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
export * from "./frontBackaAppraisal_tea.vue?vue&type=script&lang=js&"
import style0 from "./frontBackaAppraisal_tea.vue?vue&type=style&index=0&id=675d64aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d64aa",
  null
  
)

export default component.exports